module.exports = __webpack_public_path__ + "static/media/qprints-resale-marketplace-seller.e9bf9d0a.pdf";